import * as React from 'react';
interface IState {
}
interface IProps {
}


const Cargando=()=> {
        return (<div className="loading">
            <span className="spinner-border" role="status"></span>
            <p className="d-block mt-3">Cargando</p>
        </div>)
     
}
export default Cargando